import app from 'flarum/forum/app';
import { ELEMENT_LABELS } from '../common';

// Emoji icons for plain-HTML rendering of element types
const ELEMENT_ICON = {
  fire: '🔥',
  wind: '💨',
  lightning: '⚡',
  earth: '🌍',
  water: '💧'
};
// Note: text labels use the mutable ELEMENT_LABELS from common (overridable by admin)

let fetchedCards = false;
let fetchingCards = false;
async function ensureCardsFetched() {
  if (fetchedCards || fetchingCards) return;
  fetchingCards = true;
  try {
    // CardResource's JSON:API index — store.find() pushes the results into
    // the store itself; replaced the raw GET /arena/cards fetch.
    await app.store.find('arena-cards', {
      page: {
        limit: 500
      }
    });
    fetchedCards = true;
  } catch {
    // ignore — will retry next time
  }
  fetchingCards = false;
}
function esc(s) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function renderCard(span, card) {
  span.setAttribute('data-enriched', '1');
  if (card.isBonus?.()) {
    // Bonus card: neutral chip, doesn't reveal which effect it is
    const translated = app.translator.trans('forumaker-arena.forum.battle_turn.bonus_card_label');
    const label = Array.isArray(translated) ? translated.join('') : String(translated);
    span.className = 'ArenaPlayedCard ArenaPlayedCard--bonus';
    span.innerHTML = `<span class="ArenaPlayedCard-icon">⭐</span><span class="ArenaPlayedCard-el">${esc(label)}</span>`;
  } else {
    const element = card.element() ?? '';
    const icon = ELEMENT_ICON[element] ?? '🃏';
    const label = ELEMENT_LABELS[element] ?? element;
    span.className = 'ArenaPlayedCard ArenaPlayedCard--elemental';
    span.setAttribute('data-element', element);
    span.innerHTML = `<span class="ArenaPlayedCard-icon">${icon}</span><span class="ArenaPlayedCard-el">${esc(label)}</span>`;
  }
}
function enrichSpan(span) {
  if (span.getAttribute('data-enriched')) return;
  const cardId = span.getAttribute('data-card-id');
  if (!cardId) return;
  const card = app.store.getById('arena-cards', cardId);
  if (card) {
    renderCard(span, card);
  } else {
    // Card not loaded yet — fetch all cards then render
    ensureCardsFetched().then(() => {
      const c = app.store.getById('arena-cards', cardId);
      if (c) renderCard(span, c);
    });
  }
}
function enrichAll(root) {
  if (root === void 0) {
    root = document;
  }
  root.querySelectorAll('.ArenaPlayedCard[data-card-id]:not([data-enriched])').forEach(enrichSpan);
}
export default function addArenaCardEnrichment() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enrichAll());
  } else {
    enrichAll();
  }

  // Watch for newly inserted spans (Mithril re-renders the DOM)
  const observer = new MutationObserver(() => enrichAll());
  const start = () => {
    if (document.body) observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };
  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
}